import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { BranchApi } from 'api';

export const filterBranchForTableList = createAsyncThunk(
  'branch/filterBranchForTableList',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await BranchApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findBranchForCreate = createAsyncThunk(
  'branch/findBranchForCreate',
  async (_, { rejectWithValue }) => {
    try {
      const response = await BranchApi.findBranch();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findBranch = createAsyncThunk(
  'branch/findBranch',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await BranchApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createBranch = createAsyncThunk(
  'branch/createBranch',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await BranchApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneBranch = createAsyncThunk(
  'branch/findOne',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, option } = params;
      const response = await BranchApi.findOne(id, option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateBranch = createAsyncThunk(
  'branch/update',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await BranchApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  tableList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
}

const initialState: IState = {
  tableList: [],
  list: [],
  reloadFlag: false,
};

const branchSlice = createSlice({
  name: 'branch',
  initialState,
  reducers: {
    reloadBranch(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
  extraReducers: builder => {
    builder.addCase(findBranch.fulfilled, (state, action) => {
      const { data } = action.payload;

      const newData = data.map(item => {
        return {
          ...item,
          key: item.id,
          value: item.id,
        };
      });

      state.list = newData;
    });
  },
});

const { actions, reducer: branchReducer } = branchSlice;

export const { reloadBranch } = actions;

export default branchReducer;
